module.exports = __webpack_public_path__ + "static/logo-no-wording-b1dcf2e4bd802780b3d308a091e4c859.png";